import ErrorMessage from "legacy/ErrorMessage"
import {
  afterSetState,
  centsToDollars,
  dollarsToCents,
  floatsOnly,
  handleInputChange,
} from "legacy/helpers.es6"
import AdjustmentSection from "legacy/manage/AdjustmentSection"
import PricingEditSection from "legacy/manage/PricingEditSection"
import ItinerarySection from "legacy/new-reservation-form/ItinerarySection"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class EditTransientReservationModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
      arrival: this.props.arrival,
      departure: this.props.departure,
      electricId: this.props.electricId,
      currentPrice: this.props.currentPrice,
      newPrice: this.props.currentPrice,
      spaceType: this.props.spaceType,
      revenueCategoryId: this.props.revenueCategoryId,
      boaterNotification: true,
      adjustmentAmount: 0,
      adjustmentDescription: "Refund Adjustment Fee",
      usePreservedRates: true,
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.save = this.save.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleArrivalChange = this.handleArrivalChange.bind(this)
    this.handleDepartureChange = this.handleDepartureChange.bind(this)
    this.handleAdjustmentChange = this.handleAdjustmentChange.bind(this)
    this.handleAdjustmentDescriptionChange =
      this.handleAdjustmentDescriptionChange.bind(this)
    this.handlePreservedRateChange = this.handlePreservedRateChange.bind(this)
    this.resetAdjustment = this.resetAdjustment.bind(this)
    this.validator = validatorFactory()
  }

  handleInputChange(event) {
    handleInputChange(this, event)
    if (event.target.name === "spaceType") {
      // default to not using preserved rates if space type changes
      this.setState({
        usePreservedRates: event.target.value === this.props.spaceType,
      })
    }
    afterSetState(this.calculatePrice.bind(this))
  }

  handleArrivalChange(arrival) {
    this.setState({ arrival: moment(arrival).format("YYYY-MM-DD") })
    afterSetState(this.calculatePrice.bind(this))
  }

  handleDepartureChange(departure) {
    this.setState({ departure: moment(departure).format("YYYY-MM-DD") })
    afterSetState(this.calculatePrice.bind(this))
  }

  handlePreservedRateChange(event) {
    this.setState({ usePreservedRates: event.target.checked })
    afterSetState(this.calculatePrice.bind(this))
  }

  handleAdjustmentChange(event) {
    this.setState({ adjustmentAmount: floatsOnly(event.target.value) })
  }

  handleAdjustmentDescriptionChange(event) {
    this.setState({ adjustmentDescription: event.target.value })
  }

  resetAdjustment() {
    this.setState({
      adjustmentAmount: 0,
      adjustmentDescription: "Refund Adjustment Fee",
    })
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  params() {
    return {
      check_in_date: this.state.arrival,
      check_out_date: this.state.departure,
      electrical_rate_id: this.state.electricId,
      boater_notification: this.state.boaterNotification,
      reservation_id: this.props.reservationId,
      requested_space_type: this.state.spaceType,
      revenue_category_id: this.state.revenueCategoryId,
      adjustment_amount: dollarsToCents(this.state.adjustmentAmount),
      adjustment_description: this.state.adjustmentDescription,
      use_preserved_rates: this.state.usePreservedRates,
    }
  }

  calculatePrice() {
    this.setState({ calculating: true })
    $.post(this.props.calculateEndpoint, this.params(), (data) => {
      this.setState({
        newPrice: data.total_price,
        errorMessage: null,
        calculating: false,
      })
    }).fail((data) => {
      this.setState({
        errorMessage: "Error calculating price.",
        calculating: false,
      })
    })
  }

  save() {
    if (this.validator.allValid()) {
      this.setState({ saving: true })
      $.post(
        this.props.endpoint,
        { _method: "patch", ...this.params() },
        () => {
          location.reload()
        }
      ).fail((data) => {
        this.setState({
          errorMessage:
            data?.responseJSON?.error ||
            "There was an error updating the reservation.",
          saving: false,
        })
      })
    } else {
      this.validator.showMessages()
      this.forceUpdate()
    }
  }

  getFooterContent() {
    return (
      <>
        <div className="checkbox float-left ml-1 mt-2">
          <label>
            <input
              type="checkbox"
              name="boaterNotification"
              checked={this.state.boaterNotification}
              onChange={this.handleInputChange}
            />
            Send Email Update to Boater
          </label>
        </div>
        <div className="flex space-x-2 md:justify-end">
          <div className="w-full md:w-min">
            <button
              type="button"
              className="btn btn-secondary w-full"
              onClick={this.closeModal}
            >
              Cancel
            </button>
          </div>
          <div className="w-full md:w-min">
            <button
              type="button"
              className="btn btn-primary w-full"
              onClick={this.save}
              disabled={this.state.saving}
            >
              {this.state.saving ? (
                <>
                  Update Reservation
                  <i className="fa-solid fa-spin fa-spinner-third ml-2" />
                </>
              ) : (
                "Update Reservation"
              )}
            </button>
          </div>
        </div>
      </>
    )
  }

  render() {
    return (
      <div className="inline-block">
        <button
          type="button"
          className={`btn ${
            this.props.buttonClass || "btn-secondary btn-with-icon"
          }`}
          onClick={this.openModal}
        >
          {!this.props.buttonClass && (
            <i className="fa-kit fa-edit hidden md:inline" />
          )}
          Edit
        </button>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="mediumFixed"
        >
          <Modal.Header title="Edit Reservation" />
          <Modal.Body>
            <ItinerarySection
              arrival={this.state.arrival}
              departure={this.state.departure}
              spaceType={this.state.spaceType}
              spaceTypes={this.props.marinaSpaceTypes}
              revenueCategoryId={this.state.revenueCategoryId}
              revenueCategories={this.props.revenueCategories}
              handleInputChange={this.handleInputChange}
              handleArrivalChange={this.handleArrivalChange}
              handleDepartureChange={this.handleDepartureChange}
              disabledRevenueCategory={this.props.disableRevenueCategory}
            />
            <div className="form-group bs-mb-0">
              <label>Power</label>
              <select
                className="form-control"
                name="electricId"
                value={this.state.electricId}
                onChange={this.handleInputChange}
              >
                <option value="">None</option>
                {_.map(this.props.electricOptions, (electric) => (
                  <option key={electric.id} value={electric.id}>
                    {electric.powerType} -{" "}
                    {centsToDollars(electric.pricePerNight)} per night
                  </option>
                ))}
              </select>
            </div>
            <ErrorMessage>{this.state.errorMessage}</ErrorMessage>
            <hr />
            <PricingEditSection
              currentPrice={this.state.currentPrice}
              newPrice={this.state.newPrice}
              adjustmentAmount={this.state.adjustmentAmount}
              isCalculating={this.state.calculating}
              usePreservedRates={this.state.usePreservedRates}
              handlePreservedRateChange={this.handlePreservedRateChange}
              ratePreservationEnabled={this.props.ratePreservationEnabled}
              hasPreservedRates={this.props.hasPreservedRates}
            />
            <AdjustmentSection
              handleAdjustmentChange={this.handleAdjustmentChange}
              handleInputChange={this.handleAdjustmentDescriptionChange}
              resetAdjustment={this.resetAdjustment}
              adjustmentAmount={this.state.adjustmentAmount}
              adjustmentDescription={this.state.adjustmentDescription}
              currentPrice={this.state.currentPrice}
              newPrice={this.state.newPrice}
              isCalculating={this.state.calculating}
              validator={this.validator}
              resourceName="reservation"
            />
          </Modal.Body>
          <Modal.Footer>{this.getFooterContent()}</Modal.Footer>
        </Modal>
      </div>
    )
  }
}

EditTransientReservationModal.propTypes = {
  arrival: PropTypes.string.isRequired,
  departure: PropTypes.string.isRequired,
  electricId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentPrice: PropTypes.number.isRequired,
  spaceType: PropTypes.string,
  revenueCategoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buttonClass: PropTypes.string,
  marinaSpaceTypes: PropTypes.array.isRequired,
  revenueCategories: PropTypes.array,
  disableRevenueCategory: PropTypes.bool,
  electricOptions: PropTypes.array,
  calculateEndpoint: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
  reservationId: PropTypes.string,
  ratePreservationEnabled: PropTypes.bool,
  hasPreservedRates: PropTypes.bool,
}

export default EditTransientReservationModal
